export function CheckEmptyOrWhitespace(prop: any, valueType: string) {
    let r = true;
    if (valueType === 'string') {
        if (prop !== undefined && prop !== null && prop !== '') {
            r = false;
        }
    }

    if (valueType === 'date') {
        if (prop !== undefined && prop !== null && prop.toString() !== '') {
            r = false;
        }
    }
    return r;
}
